(function () {
    try {
        
    
    if (document.querySelector('.page-template-check-availability')) {
        // ANIM - BOOKING TWO BLOCS
        let titleH1 = document.querySelector(".titleBookPage");
        let logo = document.querySelector(".twoBlocks .leftBook #houseLogo");
        let bgImage = document.querySelector(".twoBlocks .leftBook .attachment-full");
        let col2Map = document.querySelector(".twoBlocks .rightBook");

        gsap.set(titleH1, {
            opacity: 0
        });
        gsap.set(logo, {
            opacity: 0
        });
        gsap.set(bgImage, {
            opacity: 0,
            scale: 1.05
        });
        gsap.set(col2Map, {
            opacity: 0,
        });

        setTimeout(() => {
            if (document.querySelector('.page-template-check-availability')) {
                
            }

            console.log("--------------- ANIMATIONS TWOCOLUMNS ---------------");
            //  ANIM - BOOKING TWO BLOCS
            var tl = gsap.timeline();
            tl.to(titleH1, {
                    duration: 0.8,
                    opacity: 1,
                    easing: Power2.easeInOut,
                })
                .to(bgImage, {
                    duration: 1.2,
                    opacity: 1,
                    scale: 1,
                    easing: Power2.easeInOut,
                })
                .to(logo, {
                    duration: 1.3,
                    opacity: 1,
                    easing: Power2.easeInOut,
                }, "-=0.4")
                .to(col2Map, {
                    duration: 1.3,
                    opacity: 1,
                    easing: Power2.easeInOut,
                }, "-=1.8");

        }, 700);
    }
    } catch(exception) {
        
    }
})();
